module.exports = __webpack_public_path__ + "static/media/1920x10801.9795574c.jpg";